import { getProjectLeadEmailError } from './partnerValidation';

export const EMPTY_PARTNER_ON_BEHALF_SELECTION = {
  partnerCompanyId: '',
  companyName: '',
  csn: '',
  partnerContactKey: '',
  partnerName: '',
  partnerEmail: '',
};

export const validatePartnerOnBehalfSelection = (selection = {}) => {
  const errors = {};

  if (!selection.partnerCompanyId) {
    errors.partnerCompanyId = 'Select a partner company';
  }

  if (!selection.csn || String(selection.csn).trim() === '') {
    errors.csn = 'CSN is required';
  }

  if (!selection.partnerName || String(selection.partnerName).trim() === '') {
    errors.partnerName = 'Partner name is required';
  }

  const partnerEmailError = getProjectLeadEmailError(selection.partnerEmail);
  if (partnerEmailError) {
    errors.partnerEmail = partnerEmailError === 'This field is required'
      ? 'Partner email is required'
      : partnerEmailError;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
